import React, { useEffect } from "react"

// components
import Layout from "../components/layout";
import SEO from "../components/seo";
import Hero from "../components/hero";
import Subhero from "../components/subhero/subhero";
import Welcome from "../components/welcome";
import BeforeAfter from "../components/clients";
import Doctors from "../components/doctors/doctors";
import Appointment from "../components/appointment";
import RecentNews from "../components/news";
import Statistics from '../components/statistics';

// AOS
import "aos/dist/aos.css";

function IndexPage() {
  let AOS;

  useEffect(() => {
    /**
     * Server-side rendering does not provide the 'document' object
     * therefore this import is required either in useEffect or componentDidMount as they
     * are exclusively executed on a client
     */
    const AOS = require("aos");
    AOS.init({
      once: true,
    });
  }, []);

  useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });

  return (
    <Layout>
      <SEO
        keywords={[`gatsby`, `tailwind`, `react`, `tailwindcss`]}
        title="Home"
      />
      <Hero />
      <Subhero />
      <Welcome />
      <BeforeAfter />
      <Doctors />
      <Statistics />
      <Appointment />
      <RecentNews />
    </Layout>
  );
}

export default IndexPage;
